import { render, staticRenderFns } from "./SparingtvRPSM.vue?vue&type=template&id=51c7ec95&"
import script from "./SparingtvRPSM.vue?vue&type=script&lang=js&"
export * from "./SparingtvRPSM.vue?vue&type=script&lang=js&"
import style0 from "./SparingtvRPSM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports